import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import { RootState } from "./types";
import * as types from "./types";
import { LanguageDto } from "@/server/app.dtos";

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  state: {
    identity: null,
    profile: null,
    languages: [],
    currentLanguage: new LanguageDto(),
    activityAreas: []
  },
  getters: {
    identity: state => {
      return state.identity;
    },
    profile: state => {
      return state.profile;
    },
    languages: state => {
      return state.languages;
    },
    currentLanguage: state => {
      return state.currentLanguage;
    },
    activityAreas: state => {
      return state.activityAreas;
    }
  },
  mutations: {
    [types.MUTATE_CORE]: (state, payload) => {
      state.identity = payload.identity;
      state.profile = payload.profile;
      state.languages = payload.languages;
      state.activityAreas = payload.activityAreas;
      state.currentLanguage = payload.languages[0] || new LanguageDto();
    },
    [types.MUTATE_IDENTITY]: (state, payload) => {
      state.identity = payload;
    },
    [types.MUTATE_PROFILE]: (state, payload) => {
      state.profile = payload;
    },
    [types.MUTATE_LANGUAGES]: (state, payload) => {
      state.languages = payload;
    },
    [types.MUTATE_ACTIVITY_AREAS]: (state, payload) => {
      state.activityAreas = payload;
    },
    [types.MUTATE_CLEAR]: state => {
      state.identity = null;
      state.profile = null;
    }
  },
  actions: {
    [types.PROFILE_UPDATE]: ({ commit }, payload) => {
      commit(types.MUTATE_PROFILE, payload);
    },
    [types.IDENTITY_UPDATE]: ({ commit }, payload) => {
      commit(types.MUTATE_IDENTITY, payload);
    },
    [types.LOGIN]: ({ commit }, payload) => {
      commit(types.MUTATE_CORE, payload);
    },
    [types.LOGOUT]: ({ commit }) => {
      commit(types.MUTATE_CLEAR);
    }
  }
};

export default new Vuex.Store<RootState>(store);
